<template>
	<div>
		<!-- Headline -->
		<div
			v-if="showTitle"
			slot="headline"
			class="flex xs-12 fs5 lh125 fw7 c1 mb2"
		>
			<div class="flex xs-6">{{ $t("associated_contracts") }}</div>
		</div>

		<!-- Body -->
		<j-card
			v-for="(item, i) in list"
			:key="i"
			class="flex xs-middle mb2 bg5 p4"
		>
			<div class="xs-6">
				<router-link
					:to="{ name: 'BindersUpdate', params: { id: item.binderId } }"
					>{{ item.binderNumber ? item.binderNumber : "---" }}</router-link
				>
			</div>
			<div class="flex xs-right xs-6" v-if="showButtons">
				<crm-icon
					class="cu2"
					name="delete"
					color="cError"
					@click.native="removeContract(item.id)"
				/>
			</div>
		</j-card>

		<!-- No data -->
		<j-card v-if="!isLoading && list && !list.length" class="bg5 p2 ta2 fs3">
			{{ $t("errors.no_data") }}
		</j-card>

		<!-- Add button -->
		<div class="xs-12 flex xs-right p2" v-if="showButtons">
			<j-button size="xsmall" @click="$modal.show('addAssociatedList')">
				{{ $t("add") }}
			</j-button>
		</div>

		<!-- Add modal -->
		<core-modal name="addAssociatedList" :headline="$t('add')">
			<div style="min-height: 300px;">
				<div class="p4">
					<core-select-binders v-model="binders"></core-select-binders>
					<j-button
						class="mt4"
						v-if="binders && binders.length"
						:isLoading="isLoading"
						@click="addContract"
						>{{ $t("add") }}</j-button
					>
				</div>
			</div>
		</core-modal>
	</div>
</template>

<script>
import JCard from "@/components/JCard"
import JButton from "@/components/JButton"
import CoreModal from "@/modules/core/components/CoreModal"
import CoreSelectBinders from "@/modules/core/components/CoreSelectBinders.vue"
import CrmIcon from "@/components/CrmIcon"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: { JCard, JButton, CoreSelectBinders, CoreModal, CrmIcon },

	props: {
		policyId: {
			type: String
		},
		showTitle: {
			type: Boolean,
			required: false,
			default: true
		},
		showButtons: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	data() {
		return {
			isLoading: false,
			list: [],
			binders: []
		}
	},

	methods: {
		async fetchList() {
			const query = gql`
				query associatedContracts($where: policyWhereInput) {
					policies(where: $where) {
						list {
							id
							associatedContracts {
								id
								contract {
									id
									name
									facts {
										type
										value {
											stringValue
										}
									}
								}
							}
						}
					}
				}
			`

			this.isLoading = true
			const res = await api({
				query,
				variables: {
					where: { id: this.policyId }
				}
			})
			this.isLoading = false

			this.list =
				res?.data?.policies?.list?.[0]?.associatedContracts?.map(item => ({
					id: item.id,
					binderId: item?.contract?.id,

					// HACK: we have this binderNumber defined as fact even though it's iportant to be displayed
					// We agreed on this with Bambi that we have it as fact
					binderNumber: item?.contract?.facts?.find(
						fact => fact.type === "binderNumber"
					)?.value?.stringValue
				})) || []
		},

		async removeContract(associatedContractId) {
			const query = gql`
				mutation removeAssociatedContractFromPolicy(
					$policyId: String!
					$associatedContractId: String!
				) {
					removeAssociatedContractFromPolicy(
						policyId: $policyId
						associatedContractId: $associatedContractId
					) {
						status
						errors
					}
				}
			`

			const currentList = JSON.parse(JSON.stringify(this.list)) // Save for optimistic UI
			this.list = this.list.filter(item => item.id !== associatedContractId) // Remove from cache

			// Call
			const res = await api({
				query,
				variables: {
					policyId: this.policyId,
					associatedContractId
				}
			})

			// Check errors
			if (res?.data?.removeAssociatedContractFromPolicy?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.data?.removeAssociatedContractFromPolicy?.errors?.[0] ||
						this.$t("errors.general")
				)
				// If error, revert optimistic UI
				this.list = currentList
				return
			}
		},

		async addContract() {
			const query = gql`
				mutation addAssociatedContractToPolicy(
					$policyId: String!
					$associatedContractId: String!
				) {
					addAssociatedContractToPolicy(
						policyId: $policyId
						associatedContractId: $associatedContractId
					) {
						status
						errors
					}
				}
			`

			this.isLoading = true
			const res = await api({
				query,
				variables: {
					policyId: this.policyId,
					associatedContractId: this.binders?.[0]?.id
				}
			})
			this.isLoading = false

			// Check errors
			if (res?.data?.addAssociatedContractToPolicy?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.data?.addAssociatedContractToPolicy?.errors?.[0] ||
						this.$t("errors.general")
				)
				return
			}

			this.$modal.hide("addAssociatedList")
			this.fetchList()
		}
	},

	mounted() {
		this.fetchList()
	}
}
</script>
